import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../data/user';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _user: User | null = null;
  private _userPromise: Promise<User | null> | null = null;
  private sessionCheckInterval: any = null;
  
  get user(): User | null {
    if (this._user == null) {
      this.refreshUser();
    }
    return this._user;
  }

  get asyncUser(): Promise<User | null> {
    if (this._user != null) {
      return Promise.resolve(this._user);
    }
    
    if (this._userPromise != null) {
      return this._userPromise;
    }
    
    // Si no hay promesa en curso, iniciar la carga del usuario
    this._userPromise = this.loadUser().finally(() => {
      this._userPromise = null;
    });
    
    return this._userPromise;
  }

  //private _user: User  = null;
  private get bookStorageURL() { return this.configService.BOOK_URL; }

  refreshingUser: boolean = false;
  
  private loadUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('DBAuthTkn');
      if (token == null) {
        this._user = null;
        resolve(null);
        return;
      }
      
      this.bookStorageURL.then(url => {
        this.http.post<User>(`${url}/users/getUserByToken`, token, { withCredentials: true }).subscribe({
          next: res => {
            if(res == null) {
              this._user = null;
              resolve(null);
              return;
            }
            this._user = User.sanitize(res);
            resolve(this._user);
          },
          error: err => {
            this._user = null;
            resolve(null);
          }
        });
      });
    });
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private router: Router
  ) {
    // Iniciar verificación automática de sesión cada 30 segundos
    //this.startSessionCheck();
  }

  // Verificación automática de sesión cada 30 segundos
  /*private startSessionCheck(): void {
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
    }
    
    this.sessionCheckInterval = setInterval(() => {
      this.checkSessionExpired();
    }, 30000); // 30 segundos
  }*/

  login(username: string, password: string): Promise<{ tkn: string, message: string }> {
    return new Promise((resolve, reject) => {
      this.bookStorageURL.then(url => {
        console.log(`Enviando login a ${url}/auth/login con usuario: ${username}`);
        this.http.post<{ tkn: string, message: string }>(`${url}/auth/login`, { username, password }, { withCredentials: true, responseType: 'text' as 'json' }).subscribe({
          next: res => {
            // Limpiar el usuario cacheado para forzar la recarga
            this._user = null;
            this._userPromise = null;
            resolve(res);
          },
          error: error => reject(error)
        })
      })
    })
  }

  /**
   * Fuerza la recarga del usuario desde el servidor
   * Útil después de un login para obtener los datos actualizados
   */
  forceReloadUser(): Promise<User | null> {
    this._user = null;
    this._userPromise = null;
    return this.asyncUser;
  }


  logout() {
    return new Promise((resolve, reject) => {
      this.bookStorageURL.then(url => {
        this.http.post<void>(`${url}/auth/logout`, localStorage.getItem('DBAuthTkn'), { withCredentials: true, responseType: 'text' as 'json' }).subscribe({
          next: res => {
            // Limpiar todo el estado del usuario
            localStorage.removeItem('DBAuthTkn');
            this._user = null;
            this._userPromise = null;
            resolve(res);
        },
          error: error => {
            // Aunque falle, limpiar el estado local
            localStorage.removeItem('DBAuthTkn');
            this._user = null;
            this._userPromise = null;
            reject(error);
          }
        })
      })
    })
  }

  refreshUser() {
    if (this.refreshingUser) {
      return;
    } else {
      this.refreshingUser = true;
      const token = localStorage.getItem('DBAuthTkn');
      if (token == null) {
        return;
      } else {
        this.bookStorageURL.then(url => {
          this.http.post<User>(`${url}/users/getUserByToken`, token, { withCredentials: true }).subscribe({
            next: res => {
              this._user = User.sanitize(res);
              this.refreshingUser = false;
            },
            error: err => {
              this._user = null;
              this.refreshingUser = false;
            }
          })
        })
      }
    }
  }


  private checkSessionExpired(): void {
    const token = localStorage.getItem('DBAuthTkn');
    
    if (!token) {
      return;
    }

    this.bookStorageURL.then(url => {
      this.http.post<boolean>(`${url}/auth/checkAccess`, { token }, { withCredentials: true }).subscribe({
        next: (isValid) => {
          if (!isValid) {
            this.handleExpiredSession();
          }
        },
        error: (error) => {
          console.error('Error verificando sesión:', error);
          this.handleExpiredSession();
        }
      });
    });
  }

  private handleExpiredSession(): void {
    alert('La sesión ha caducado. Por favor, vuelva a iniciar sesión');
    localStorage.removeItem('DBAuthTkn');
    this._user = null;
    this._userPromise = null;
    
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
      this.sessionCheckInterval = null;
    }
    
    window.location.href = 'books/login';
  }

  // Renovar token de sesión de usuario
  renewUserSessionToken(): void {
    const token = localStorage.getItem('DBAuthTkn');
    
    if (!token) {
      return;
    }

    this.bookStorageURL.then(url => {
      this.http.post<{ token: string }>(`${url}/auth/renewToken`, token, { withCredentials: true }).subscribe({
        next: (response) => {
          if (response && response.token) {
            localStorage.setItem('DBAuthTkn', response.token);
          }
        },
        error: () => {
          // Silencioso, no mostrar errores
        }
      });
    });
  }

}

